import useTranslation from 'next-translate/useTranslation';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import CustomEventTypes from '@/utils/analytics/customEventTypes';

// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'
import CouponOfferIcon from '../../icons/CouponOffer';
import Paragraph, { VARIANT } from '../../Paragraph';
interface Props {
  onClick: VoidFunction;
}
const CouponNotApplied = ({
  onClick
}: Props) => {
  const {
    t
  } = useTranslation('cart');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const onAvailOfferClick = () => {
    trackCustomEvent(CustomEventTypes.CHECK_COUPON_OFFERS);
    onClick();
  };
  return <button className="flex justify-between items-center mt-2 p-4 border border-solid rounded-lg w-full" onClick={onAvailOfferClick} data-testid="apply-coupon-button-2" data-sentry-component="CouponNotApplied" data-sentry-source-file="CouponNotApplied.tsx">
      <div className="flex">
        <CouponOfferIcon className="fill-transparent stroke-black w-6 h-6 storke-[1.13]" data-sentry-element="CouponOfferIcon" data-sentry-source-file="CouponNotApplied.tsx" />
        <Paragraph variant={VARIANT.MEDIUM} className="ml-2" data-sentry-element="Paragraph" data-sentry-source-file="CouponNotApplied.tsx">
          {t('avail_offers')}
        </Paragraph>
      </div>
      <span className="text-primary-80 text-xl">&gt;</span>
    </button>;
};
export default CouponNotApplied;